import { Session } from "@paywithglide/glide-js";
import { ArrowLeftRight } from "lucide-react";
import Alert from "./Alert";
import { refundChainOf } from "../lib/refundChain";

type Props = {
  session: Session;
  className?: string;
};

export default function RefundConversionNotice({ session, className }: Props) {
  const refundChain = refundChainOf(session);
  if (!refundChain.isConverted) {
    return null;
  }

  const paidSymbol = session.actualPaymentCurrencySymbol;
  const isSameToken = paidSymbol === refundChain.currencySymbol;

  return (
    <Alert
      icon={<ArrowLeftRight strokeWidth={2.25} className="w-4 h-4" />}
      title={`Refund in ${refundChain.currencySymbol} on ${refundChain.name}`}
      subtitle={
        isSameToken
          ? `Your ${paidSymbol} payment was processed on ${refundChain.name}. Please enter a ${refundChain.name} address to receive your refund.`
          : `Your ${paidSymbol} payment was processed and converted on arrival. Please enter a ${refundChain.name} address to receive your refund in ${refundChain.currencySymbol}.`
      }
      className={className}
    />
  );
}
